export default __webpack_public_path__ + "static/media/purple-selected.7b5aa6cf.jpg";